import { render, staticRenderFns } from "./NavAccounts.vue?vue&type=template&id=2b9c031c&scoped=true"
import script from "./NavAccounts.vue?vue&type=script&lang=js"
export * from "./NavAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c031c",
  null
  
)

export default component.exports